import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { LogoutUser } from "components/authentication/config/AuthApi";
import paths from "routes/paths";

const IDLE_TIMEOUT = 30 * 60 * 1000; // 30 minute for testing

const UseerAutoLogout = () => {
  const dispatch = useDispatch();
  const idleTimerRef = useRef(null);
  const lastActivityRef = useRef(Date.now());

  const handleLogout = () => {
    // Clear Redux state
    dispatch(LogoutUser());

    // Clear local storage
    localStorage.clear(); // safer than just removing "authToken"

    // Redirect and reload — this clears everything
    window.location.href = paths.login;
  };

  const resetIdleTimer = () => {
    lastActivityRef.current = Date.now();
    if (idleTimerRef.current) clearTimeout(idleTimerRef.current);

    idleTimerRef.current = setTimeout(() => {
      const now = Date.now();
      if (now - lastActivityRef.current >= IDLE_TIMEOUT) {
        handleLogout();
      }
    }, IDLE_TIMEOUT);
  };

  useEffect(() => {
    const events = ["mousemove", "click", "keypress", "scroll"];
    const handleActivity = () => resetIdleTimer();

    events.forEach((event) => window.addEventListener(event, handleActivity));

    resetIdleTimer();

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity)
      );
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
    };
  }, []);

  return null;
};

export default UseerAutoLogout;
